module.exports = __webpack_public_path__ + "media/assets/icons/hyoka-point-icon-a7d84e3e9cdd5e6784cc4500c2b94bcb.svg";